/**
 * v3.15-1170 — Ghost™ brand mark.
 *
 * Single source of truth for the Ghost logo. Replaces the lucide `Ghost`
 * placeholder icon everywhere on the public site so Ghost reads as a
 * branded product, not a stock illustration.
 */
const SIZES = {
  xs:  'h-4 w-4',
  sm:  'h-5 w-5',
  md:  'h-7 w-7',
  lg:  'h-10 w-10',
  xl:  'h-16 w-16',
  '2xl': 'h-24 w-24',
  hero: 'h-40 w-40 lg:h-56 lg:w-56',
};

/**
 * @param {object}  props
 * @param {keyof typeof SIZES} [props.size]   - Visual scale.
 * @param {boolean} [props.invert]            - Inverts to white-on-dark.
 *                                              The asset is already
 *                                              white-on-black, so this is
 *                                              a no-op visually but signals
 *                                              intent. Kept for API parity.
 * @param {string}  [props.className]         - Extra utility classes.
 * @param {string}  [props.testId]
 */
const GhostLogo = ({ size = 'md', className = '', testId = 'ghost-logo', alt = 'Ghost — AI Operations Assistant' }) => (
  <img
    src="/marketing/ghost-mark.png"
    alt={alt}
    className={`${SIZES[size]} object-contain select-none ${className}`}
    draggable="false"
    data-testid={testId}
  />
);

export default GhostLogo;
